(function () {
  'use strict';

  angular
    .module('garanteasyApp')
    .factory('ShopLookup', ShopLookup);

  ShopLookup.$inject = ['$resource', 'API_URI'];

  function ShopLookup($resource, API_URI) {
    var resourceUrl = API_URI + 'api/_lookup/shops';

    return $resource(resourceUrl, {}, {
      'query': {method: 'GET', isArray: true}
    });
  }
})();
